// Section 9 and 18: housing. Beds against people, rough sleepers and overcrowded households,
// and the housing policy (who gets beds first, overcrowding, splitting households). Props only.
import type { HousingMode, HousingPolicy } from '../../sim/api';
import type { HousingRow } from '../../viewModels/build';
import { buildText } from '../text/en';

interface Props {
  housing: HousingRow;
  canEdit: boolean;
  onChange: (policy: HousingPolicy) => void;
}

const MODES: readonly HousingMode[] = ['families-first', 'workers-first', 'first-come', 'manual'];

export function HousingPanel({ housing, canEdit, onChange }: Props) {
  const policy = housing.policy;
  return (
    <div class="build__housing">
      <ul class="build__facts">
        <li>{buildText.housingSummary(housing.beds, housing.people)}</li>
        {housing.rough > 0 && <li>{buildText.rough(housing.rough)}</li>}
        {housing.crowdedHouseholds > 0 && <li>{buildText.crowded(housing.crowdedHouseholds)}</li>}
      </ul>
      <div class="build__controls">
        <label class="field">
          <span class="field__label">{buildText.housingMode}</span>
          <select
            value={policy.mode}
            disabled={!canEdit}
            onChange={(e) => onChange({ ...policy, mode: e.currentTarget.value as HousingMode })}
          >
            {MODES.map((m) => (
              <option key={m} value={m}>
                {buildText.housingModes[m]}
              </option>
            ))}
          </select>
        </label>
        <label class="field field--check">
          <input
            type="checkbox"
            checked={policy.allowOvercrowding}
            disabled={!canEdit}
            onChange={(e) => onChange({ ...policy, allowOvercrowding: e.currentTarget.checked })}
          />
          {buildText.allowOvercrowding}
        </label>
        <label class="field field--check">
          <input
            type="checkbox"
            checked={policy.splitHouseholds === true}
            disabled={!canEdit}
            onChange={(e) => onChange({ ...policy, splitHouseholds: e.currentTarget.checked })}
          />
          {buildText.splitHouseholds}
        </label>
      </div>
    </div>
  );
}
